import Noty from 'noty';
import { map } from 'lodash';
import UtilHelper from './utils';

interface IErrorMessage {
  data: {
    code: number;
    message: string;
    errors: any[];
  };
}

interface IAction {
  label: string;
  action: Function;
}

Noty.overrideDefaults({
  // theme: 'metroui',
  layout: 'topRight',
  closeWith: ['click'],
  timeout: 5000,
  dismissQueue: true,
  force: false,
  maxVisible: 5,
  progressBar: false,
});

export default class NotificationHelper {
  static success(message: string, container: string = null) {
    new Noty({
      text: message,
      type: 'success',
      container,
    }).show();
  }

  static error(message: IErrorMessage | string, container: string = null) {
    if (typeof message === 'string') {

      new Noty({
        text: UtilHelper.escapeHtml(message),
        type: 'error',
        container,
      }).show();
      return;
    }

    let errorMessage = 'Something went wrong';

    if (typeof message === 'string') {
      errorMessage = message;
    }

    if (message && message.data) {
      if (message.data.code === 100) {
        return;
      }

      // normal error
      if (message.data.message) {
        errorMessage = message.data.message;
      }

      // validation error
      if (message.data.errors) {
        errorMessage = map(message.data.errors, (k) => map(k, (text) => text)).join('<br><br>');
      }
    }

    new Noty({
      text: errorMessage,
      type: 'error',
      container,
    }).show();
  }
}
